import React from 'react';
import { useSelector } from 'react-redux';
import Loading from './Loading'; 

const GlobalLoading = () => {
  const { isLoading } = useSelector((state) => state.loading);

  if (!isLoading) return null;

  return <Loading />;
};

export default GlobalLoading;